/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    d="M18.8571 0C21.6975 0 24 2.3025 24 5.1429V18.857C24 21.6975 21.6975 24 18.8571 24H5.1429C2.3025 24 0 21.6975 0 18.8571V5.1429C0 2.3025 2.3025 0 5.1429 0H18.857Zm0 2.0571H5.1429c-1.7042 0-3.0858 1.3816-3.0858 3.0858V18.857c0 1.7042 1.3816 3.0858 3.0858 3.0858H18.857c1.7042 0 3.0858-1.3816 3.0858-3.0858V5.1429c0-1.7042-1.3816-3.0858-3.0858-3.0858Zm-9.6 10.2858c1.3255 0 2.4 1.0745 2.4 2.4v1.3714c0 1.3255-1.0745 2.4-2.4 2.4H6.5143c-1.3255 0-2.4-1.0745-2.4-2.4v-1.3714c0-1.3255 1.0745-2.4 2.4-2.4H9.257Zm0 2.0571H6.5143a.3429.3429 0 0 0-.3429.3429v1.3714c0 .1893.1535.3428.3429.3428H9.257a.3428.3428 0 0 0 .3429-.3428v-1.3714a.3429.3429 0 0 0-.3429-.3429Zm8.2286-10.2857c1.3255 0 2.4 1.0745 2.4 2.4v1.3714c0 1.3255-1.0745 2.4-2.4 2.4H6.5143c-1.3255 0-2.4-1.0745-2.4-2.4V6.5143c0-1.3255 1.0745-2.4 2.4-2.4h10.9714Zm0 2.0571H6.5143a.3429.3429 0 0 0-.3429.3429v1.3714c0 .1894.1535.3429.3429.3429h10.9714a.3429.3429 0 0 0 .3429-.3429V6.5143a.3429.3429 0 0 0-.3429-.3429Z"
  />,
  'MenuProjectSheet'
);
